import React, { Component } from 'react'
import { Link } from 'react-router-dom'

class NewRole extends Component {
        constructor (props) {
                super(props)
                this.state = {
                  slug: '',
                  name: '',
                  permission: [],
                  errors: [],
                  permissions: []
                }
                this.handleFieldChange = this.handleFieldChange.bind(this)
                this.handleCreate = this.handleCreate.bind(this)
                this.hasError = this.hasError.bind(this)
                this.renderError = this.renderError.bind(this)
                this.fireRedirect = this.fireRedirect.bind(this);
        }
        
        componentDidMount () {
                axios.get('/api/permissions').then(response => {
                        this.setState({
                              permissions: response.data
                        })
                })
        }
        
        fireRedirect(e) {
            e.preventDefault()
            this.props.history.push(e.currentTarget.getAttribute('href'));
        }

        handleFieldChange (event) {
                if(event.target.name == 'permission'){
                        const options = this.state.permission
                        let index

                        if (event.target.checked) {
                          options.push(+event.target.value)
                        } else {
                          index = options.indexOf(+event.target.value)
                          options.splice(index, 1)
                        }

                        this.setState({ permission: options })
                } else{
                       this.setState({
                        [event.target.name]: event.target.value
                      }) 
                }
        }

        handleCreate (event) {
                event.preventDefault()
                const { history } = this.props

                const newRole = {
                  slug: this.state.slug,
                  name: this.state.name,
                  permission: this.state.permission
                }
                
                axios.post('/api/roles', newRole)
                .then(response => {
                        if(response.data.success){
                                this.props.history.push('/roles')
                        } else {
                                this.setState({
                                        errors: response.data.errors
                                })
                        }
                })
                .catch(error => {
                        this.setState({
                                errors: error.response.data.errors
                        })
                })
        }

        hasError () {
                var count = 0;
                $.each(this.state.errors, function () {
                        count++;
                });
                return count;
        }

        renderError () {
                if (this.hasError()) {
                        return (
                                <div className="alert alert-danger">
                                        <ul className="reset-list">
                                                {Object.keys(this.state.errors).map((key, i) => 
                                                        <li key={i}>{this.state.errors[key]}</li>
                                                )}
                                        </ul>
                                </div>
                        )
                }
        }

        render() {
            return (
                <React.Fragment>
                    <div className="row">
                        <div className="col-sm-12">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item"><a onClick={this.fireRedirect} href="/home">ダッシュボード</a></li>
                                    <li className="breadcrumb-item"><a onClick={this.fireRedirect} href="/roles">ロール一覧</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">ロール登録</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <main id="main">
                        <div className="row justify-content-md-center">
                            <div className="col-sm-6">
                                <form className="form-horizontal" onSubmit={this.handleCreate}>
                                    <div className="card mb-3">
                                        <div className="card-header p-4 border-bottom-0"><h4 className="mb-0">ロール登録</h4></div>
                                        <div className="card-body">
                                                {this.renderError()}
                                                <div className="form-group row">
                                                        <label className="col-sm-4 col-form-label text-right" htmlFor="slug">スラッグ</label>
                                                        <div className="col-md-8">
                                                                <input id="slug" name="slug" type="text" placeholder="" className="form-control" required onChange={this.handleFieldChange} />
                                                        </div>
                                                </div>
                                                <div className="form-group row">
                                                        <label className="col-sm-4 col-form-label text-right" htmlFor="name">名前</label>
                                                        <div className="col-md-8">
                                                                <input id="name" name="name" type="text" placeholder="" className="form-control" onChange={this.handleFieldChange} />
                                                        </div>
                                                </div>
                                                <div className="form-group row">
                                                        <label className="col-sm-4 col-form-label text-right" htmlFor="permission">権限</label>
                                                        <div className="col-md-8">
                                                                {this.state.permissions.map((p, v) =>
                                                                        <div key={v}>
                                                                                <input value={p.id} id={"permission_" + p.id} type="checkbox" name="permission" className="form-checkbox" onChange={this.handleFieldChange} /> <label htmlFor={"permission_" + p.id}>{p.name}</label>
                                                                        </div>
                                                                )}
                                                        </div>
                                                </div>
                                        </div>
                                        <div className="card-footer text-center">
                                            <button className="btn btn-primary btn-radius btn-lg"><span className="size-inherit">保存する</span></button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </main>
                    </React.Fragment>
                )
        }
}

export default NewRole